import {
    BuyerCommentThreadOverview,
    CommentThreadOverview,
    CommentThreadOverviewTotals,
    PossibleChatFollower,
    CommentThreadSearchResult,
    CommentThreadType,
} from '@/types';
import { request, getChatApiUrl } from '@/utils/ajax';
import { FileData } from '@ygtechnologies/rubus-frontend-utilities';
import { BygrModule } from '@ygtechnologies/bygr-frontend-component-library';

export function getProjectCommentThread(projectId: number): Promise<CommentThreadSearchResult> {
    return request(getChatApiUrl() + `/api/comment-threads/project-thread/${projectId}`, {
        method: 'GET',
    }).then((x) => x.json());
}

export function addCommentThread(
    residentialUnitId: number,
    name: string,
    IncludesBuyer: boolean,
    followerProjectMemberIds: number[]
): Promise<number> {
    return request(getChatApiUrl() + `/api/comment-threads/`, {
        method: 'POST',
        json: true,
        body: {
            residentialUnitId,
            name,
            IncludesBuyer,
            followerProjectMemberIds,
        },
    }).then((x) => x.json());
}

export function getPossibleChatFollowers(projectId: number, includesBuyer: boolean): Promise<PossibleChatFollower[]> {
    return request(getChatApiUrl() + `/api/follower/possible-followers`, {
        method: 'GET',
        query: { projectId, includesBuyer, module: BygrModule.ChangeManagement },
        json: true,
    }).then((x) => x.json());
}

export interface AddMultiCommentOptions {
    residentialUnitIds: number[];
    profileId: number;
    message: string;
    attachment: FileData | null;
    notifyBySms: boolean;
    notifyByEmail: boolean;
}

export function sendMultiMessage(options: AddMultiCommentOptions) {
    return request(getChatApiUrl() + `/api/comment-threads/multi-message`, {
        method: 'POST',
        body: options,
        json: true,
    });
}

export function getCommentOverviewForBuyer(residentialUnitId: number): Promise<BuyerCommentThreadOverview[]> {
    return request(getChatApiUrl() + `/api/comment-threads/buyer`, {
        query: { residentialUnitId },
    }).then((x) => x.json());
}
export function getCommentsOverview(options: CommentsOverviewOptions): Promise<CommentThreadOverview[]> {
    if (options.projectIds.length === 0) {
        return Promise.resolve([]);
    }

    return request(getChatApiUrl() + `/api/comment-threads/overview`, {
        query: options,
    }).then((x) => x.json());
}

export function getCommentsOverviewTotals(options: CommentsOverviewOptions): Promise<CommentThreadOverviewTotals[]> {
    if (options.projectIds.length === 0) {
        return Promise.resolve([]);
    }

    return request(getChatApiUrl() + `/api/comment-threads/overview/totals`, {
        query: options,
    }).then((x) => x.json());
}

export interface CommentsOverviewOptions {
    projectIds: number[];
    threadTypes?: CommentThreadType[];
}

export interface ThreadRelationInfo {
    projectId: number;
    residentialUnitId: number;
    entityId: number;
    threadType: CommentThreadType;
    buyerIncluded: boolean;
}

export function getCommentThreadRelationInfo(threadId: number): Promise<ThreadRelationInfo> {
    return request(getChatApiUrl() + `/api/comment-threads/${threadId}/relation`).then((x) => x.json());
}
